import { render, staticRenderFns } from "./WebPartFormShopWithProductRunner.vue?vue&type=template&id=1457fc25&scoped=true&"
import script from "./WebPartFormShopWithProductRunner.vue?vue&type=script&lang=js&"
export * from "./WebPartFormShopWithProductRunner.vue?vue&type=script&lang=js&"
import style0 from "./WebPartFormShopWithProductRunner.vue?vue&type=style&index=0&id=1457fc25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1457fc25",
  null
  
)

export default component.exports